"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedHatDistroSDKProvider = void 0;
const GenericDistroSDKProvider_1 = require("./GenericDistroSDKProvider");
class RedHatDistroSDKProvider extends GenericDistroSDKProvider_1.GenericDistroSDKProvider {
    constructor(distroVersion, context, utilContext, executor = null) {
        super(distroVersion, context, utilContext, executor);
    }
    myVersionDetails() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const distroVersions = this.distroJson[this.distroVersion.distro][this.distroVersionsKey];
        const targetVersion = Math.floor(parseFloat(this.distroVersion.version[0])).toFixed(1);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const versionData = distroVersions.filter((x) => x[this.versionKey] === String(targetVersion));
        return versionData;
    }
}
exports.RedHatDistroSDKProvider = RedHatDistroSDKProvider;
//# sourceMappingURL=RedHatDistroSDKProvider.js.map